import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-54152511"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subtitle-1" }
const _hoisted_2 = { class: "subtitle-1" }
const _hoisted_3 = { class: "subtitle-1" }
const _hoisted_4 = { class: "subtitle-1" }
const _hoisted_5 = { class: "subtitle-1" }
const _hoisted_6 = { class: "test-buttons" }
const _hoisted_7 = { class: "test-result" }

import SelectItems from "@/utils/SelectItems";
import {computed, Reactive, reactive, ref} from "vue";
import {Guild} from "@/types/Guild";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {GuildSettings} from "@/types/GuildSettings";
import config from "@/config.json";
import TemplateInput from "@/components/TemplateInput.vue";
import TemplateCompilationError from "@/components/TemplateCompilationError.vue";
import EmbedInput from "@/components/EmbedInput.vue";
import {Embed} from "@/types/Embed";


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildGreetingsView',
  props: {
    settings: {}
  },
  emits: ['submitted'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
const store = useStore()
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let roles = SelectItems.roles(guild.value!.roles!, false)
let channels = SelectItems.channels(guild.value!.channels!, false)
let settings: Reactive<GuildSettings> = reactive(JSON.parse(JSON.stringify(props.settings)));
let valid = ref(true);
let submitting = ref(false);
let templateCompilationError = ref(false);
let tests: Reactive<Record<string, boolean>> = reactive({});
let testsThrottle: Reactive<Record<string, boolean>> = reactive({});
let testSnackbar = ref(false);
let testSuccess = ref(true);
const joinRules = [
  (channel: string) => (!!channel || '')
]

let embed: Embed = {enabled: false}
if (!settings.greetings.join?.enabled) settings.greetings.join = {enabled: false, message: '', embed}
if (!settings.greetings.leave?.enabled) settings.greetings.leave = {enabled: false, message: '', embed}
if (!settings.greetings.dm?.enabled) settings.greetings.dm = {enabled: false, message: '', embed}
if (!settings.greetings.joinRoles) settings.greetings.joinRoles = []

async function submit() {
  templateCompilationError.value = false;
  submitting.value = true;
  if (!settings.greetings.join.channel ||
      (!settings.greetings.join.message?.trim()?.length && !settings.greetings.join.embed?.enabled))
    settings.greetings.join.enabled = false;
  if (!settings.greetings.leave.channel ||
      (!settings.greetings.leave.message?.trim()?.length && !settings.greetings.leave.embed?.enabled))
    settings.greetings.leave.enabled = false;
  if (!settings.greetings.dm.message?.trim()?.length && !settings.greetings.dm.embed?.enabled)
    settings.greetings.dm.enabled = false;
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/greetings`,
      {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token') as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify(settings.greetings)
      })
  let body = await response.json()
  templateCompilationError.value = body.message === "Template compilation error"
  if (response.ok) emit('submitted', 'success', settings)
  else emit('submitted', 'error')
  submitting.value = false;
}

async function test(type: 'join' | 'leave') {
  if (testsThrottle[type]) return
  tests[type] = true
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/tests/greetings`,
      {
        method: 'POST',
        headers: {
          Authorization: localStorage.getItem('token') as string,
          'Content-Type': 'application/json'
        }, body: JSON.stringify({type})
      })
  tests[type] = false
  testsThrottle[type] = true
  setTimeout(() => testsThrottle[type] = false, 10000)
  testSuccess.value = response.ok
  testSnackbar.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: _unref(valid),
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
  }, {
    default: _withCtx(() => [
      (_unref(templateCompilationError))
        ? (_openBlock(), _createBlock(TemplateCompilationError, {
            key: 0,
            class: "error"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('GuildGreetings.subtitles.joinMessage')), 1),
      _createVNode(_component_v_switch, {
        modelValue: _unref(settings).greetings.join.enabled,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings).greetings.join.enabled) = $event)),
        class: "fit-content",
        color: "primary",
        "hide-details": "",
        label: _ctx.$t(`GuildGreetings.subtitles.enabled`)
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_v_select, {
        modelValue: _unref(settings).greetings.join.channel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(settings).greetings.join.channel) = $event)),
        class: "channel-select",
        color: "primary",
        rules: joinRules,
        disabled: !_unref(settings).greetings.join.enabled,
        items: _unref(channels),
        label: _ctx.$t(`GuildGreetings.subtitles.channel`)
      }, null, 8, ["modelValue", "disabled", "items", "label"]),
      _createVNode(TemplateInput, {
        modelValue: _unref(settings).greetings.join.message,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(settings).greetings.join.message) = $event)),
        class: "template",
        variables: ['member', 'guild'],
        disabled: !_unref(settings).greetings.join.enabled,
        counter: 1500
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(EmbedInput, {
        modelValue: _unref(settings).greetings.join.embed,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(settings).greetings.join.embed) = $event)),
        class: "embed",
        disabled: !_unref(settings).greetings.join.enabled
      }, null, 8, ["modelValue", "disabled"]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('GuildGreetings.subtitles.leaveMessage')), 1),
      _createVNode(_component_v_switch, {
        modelValue: _unref(settings).greetings.leave.enabled,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(settings).greetings.leave.enabled) = $event)),
        class: "fit-content",
        color: "primary",
        "hide-details": "",
        label: _ctx.$t(`GuildGreetings.subtitles.enabled`)
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_v_select, {
        modelValue: _unref(settings).greetings.leave.channel,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(settings).greetings.leave.channel) = $event)),
        class: "channel-select",
        color: "primary",
        rules: joinRules,
        disabled: !_unref(settings).greetings.leave.enabled,
        items: _unref(channels),
        label: _ctx.$t(`GuildGreetings.subtitles.channel`)
      }, null, 8, ["modelValue", "disabled", "items", "label"]),
      _createVNode(TemplateInput, {
        modelValue: _unref(settings).greetings.leave.message,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(settings).greetings.leave.message) = $event)),
        class: "template",
        variables: ['member', 'guild'],
        disabled: !_unref(settings).greetings.leave.enabled,
        counter: 1500
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(EmbedInput, {
        modelValue: _unref(settings).greetings.leave.embed,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(settings).greetings.leave.embed) = $event)),
        class: "embed",
        disabled: !_unref(settings).greetings.leave.enabled
      }, null, 8, ["modelValue", "disabled"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('GuildGreetings.subtitles.joinDM')), 1),
      _createVNode(_component_v_switch, {
        modelValue: _unref(settings).greetings.dm.enabled,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(settings).greetings.dm.enabled) = $event)),
        class: "fit-content",
        color: "primary",
        "hide-details": "",
        label: _ctx.$t(`GuildGreetings.subtitles.enabled`)
      }, null, 8, ["modelValue", "label"]),
      _createVNode(TemplateInput, {
        modelValue: _unref(settings).greetings.dm.message,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(settings).greetings.dm.message) = $event)),
        class: "template",
        variables: ['member', 'guild'],
        disabled: !_unref(settings).greetings.dm.enabled,
        counter: 1500
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(EmbedInput, {
        modelValue: _unref(settings).greetings.dm.embed,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(settings).greetings.dm.embed) = $event)),
        class: "embed",
        disabled: !_unref(settings).greetings.dm.enabled
      }, null, 8, ["modelValue", "disabled"]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('GuildGreetings.subtitles.joinRoles')), 1),
      _createVNode(_component_v_select, {
        modelValue: _unref(settings).greetings.joinRoles,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(settings).greetings.joinRoles) = $event)),
        class: "roles-select",
        label: _ctx.$t('GuildGreetings.subtitles.selectRoles'),
        color: "primary",
        "persistent-hint": "",
        multiple: "",
        chips: "",
        "closable-chips": "",
        items: _unref(roles)
      }, null, 8, ["modelValue", "label", "items"]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('GuildGreetings.subtitles.tests')), 1),
      (_unref(settings).useTimeout)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 1,
            class: "alert",
            border: "start",
            color: "alert",
            title: _ctx.$t('GuildGreetings.subtitles.testsTitle'),
            variant: "tonal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('GuildGreetings.subtitles.testsDescription')), 1)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_btn, {
          class: "test-button",
          color: "primary",
          variant: "tonal",
          loading: _unref(tests).join,
          "prepend-icon": "person_add",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (test('join')))
        }, {
          default: _withCtx(() => [
            (_unref(testsThrottle).join)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  activator: "parent",
                  location: "top",
                  "open-on-click": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('GuildGreetings.subtitles.throttle')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildGreetings.subtitles.joinTest')), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_v_btn, {
          class: "test-button",
          color: "primary",
          variant: "tonal",
          loading: _unref(tests).leave,
          "prepend-icon": "person_remove",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (test('leave')))
        }, {
          default: _withCtx(() => [
            (_unref(testsThrottle).leave)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  activator: "parent",
                  location: "top",
                  "open-on-click": ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('GuildGreetings.subtitles.throttle')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildGreetings.subtitles.leaveTest')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _createVNode(_component_v_snackbar, {
        modelValue: _unref(testSnackbar),
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(testSnackbar) ? (testSnackbar).value = $event : testSnackbar = $event)),
        color: "block"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: _unref(testSuccess) ? 'green' : 'pink',
            variant: "text",
            ripple: "",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_isRef(testSnackbar) //@ts-ignore
 ? testSnackbar.value = false : testSnackbar = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('GuildGreetings.subtitles.close')), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(testSuccess) ? _ctx.$t('GuildGreetings.subtitles.testCompleted') : _ctx.$t('GuildGreetings.subtitles.testError')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_btn, {
        class: "submit",
        disabled: _unref(valid) === false,
        loading: _unref(submitting),
        size: "large",
        color: "secondary",
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "save-icon" }, {
            default: _withCtx(() => [
              _createTextVNode("save")
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('GuildEconomy.submit')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})